
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
function $6f019d1f45ba2738$export$2e2bcd8739ae039(targetElements, defaultProps) {
    if (!targetElements.length) return;
    ScrollReveal({
        reset: false
    });
    targetElements.forEach(({ element: element, animation: animation })=>{
        ScrollReveal().reveal(element, Object.assign({}, defaultProps, animation));
    });
}


var $b5f6d4efc654cf78$exports = {};
'use strict';
var $b5f6d4efc654cf78$var$classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
/**
 * Created by Sergiu Șandor (micku7zu) on 1/27/2017.
 * Original idea: https://github.com/gijsroge/tilt.js
 * MIT License.
 * Version 1.8.1
 */ var $b5f6d4efc654cf78$var$VanillaTilt = function() {
    function VanillaTilt(element) {
        var settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        $b5f6d4efc654cf78$var$classCallCheck(this, VanillaTilt);
        if (!(element instanceof Node)) throw "Can't initialize VanillaTilt because " + element + " is not a Node.";
        this.width = null;
        this.height = null;
        this.clientWidth = null;
        this.clientHeight = null;
        this.left = null;
        this.top = null;
        // for Gyroscope sampling
        this.gammazero = null;
        this.betazero = null;
        this.lastgammazero = null;
        this.lastbetazero = null;
        this.transitionTimeout = null;
        this.updateCall = null;
        this.event = null;
        this.updateBind = this.update.bind(this);
        this.resetBind = this.reset.bind(this);
        this.element = element;
        this.settings = this.extendSettings(settings);
        this.reverse = this.settings.reverse ? -1 : 1;
        this.resetToStart = VanillaTilt.isSettingTrue(this.settings["reset-to-start"]);
        this.glare = VanillaTilt.isSettingTrue(this.settings.glare);
        this.glarePrerender = VanillaTilt.isSettingTrue(this.settings["glare-prerender"]);
        this.fullPageListening = VanillaTilt.isSettingTrue(this.settings["full-page-listening"]);
        this.gyroscope = VanillaTilt.isSettingTrue(this.settings.gyroscope);
        this.gyroscopeSamples = this.settings.gyroscopeSamples;
        this.elementListener = this.getElementListener();
        if (this.glare) this.prepareGlare();
        if (this.fullPageListening) this.updateClientSize();
        this.addEventListeners();
        this.reset();
        if (this.resetToStart === false) {
            this.settings.startX = 0;
            this.settings.startY = 0;
        }
    }
    VanillaTilt.isSettingTrue = function isSettingTrue(setting) {
        return setting === "" || setting === true || setting === 1;
    };
    /**
   * Method returns element what will be listen mouse events
   * @return {Node}
   */ VanillaTilt.prototype.getElementListener = function getElementListener() {
        if (this.fullPageListening) return window.document;
        if (typeof this.settings["mouse-event-element"] === "string") {
            var mouseEventElement = document.querySelector(this.settings["mouse-event-element"]);
            if (mouseEventElement) return mouseEventElement;
        }
        if (this.settings["mouse-event-element"] instanceof Node) return this.settings["mouse-event-element"];
        return this.element;
    };
    /**
   * Method set listen methods for this.elementListener
   * @return {Node}
   */ VanillaTilt.prototype.addEventListeners = function addEventListeners() {
        this.onMouseEnterBind = this.onMouseEnter.bind(this);
        this.onMouseMoveBind = this.onMouseMove.bind(this);
        this.onMouseLeaveBind = this.onMouseLeave.bind(this);
        this.onWindowResizeBind = this.onWindowResize.bind(this);
        this.onDeviceOrientationBind = this.onDeviceOrientation.bind(this);
        this.elementListener.addEventListener("mouseenter", this.onMouseEnterBind);
        this.elementListener.addEventListener("mouseleave", this.onMouseLeaveBind);
        this.elementListener.addEventListener("mousemove", this.onMouseMoveBind);
        if (this.glare || this.fullPageListening) window.addEventListener("resize", this.onWindowResizeBind);
        if (this.gyroscope) window.addEventListener("deviceorientation", this.onDeviceOrientationBind);
    };
    /**
   * Method remove event listeners from current this.elementListener
   */ VanillaTilt.prototype.removeEventListeners = function removeEventListeners() {
        this.elementListener.removeEventListener("mouseenter", this.onMouseEnterBind);
        this.elementListener.removeEventListener("mouseleave", this.onMouseLeaveBind);
        this.elementListener.removeEventListener("mousemove", this.onMouseMoveBind);
        if (this.gyroscope) window.removeEventListener("deviceorientation", this.onDeviceOrientationBind);
        if (this.glare || this.fullPageListening) window.removeEventListener("resize", this.onWindowResizeBind);
    };
    VanillaTilt.prototype.destroy = function destroy() {
        clearTimeout(this.transitionTimeout);
        if (this.updateCall !== null) cancelAnimationFrame(this.updateCall);
        this.element.style.willChange = "";
        this.element.style.transition = "";
        this.element.style.transform = "";
        this.resetGlare();
        this.removeEventListeners();
        this.element.vanillaTilt = null;
        delete this.element.vanillaTilt;
        this.element = null;
    };
    VanillaTilt.prototype.onDeviceOrientation = function onDeviceOrientation(event) {
        if (event.gamma === null || event.beta === null) return;
        this.updateElementPosition();
        if (this.gyroscopeSamples > 0) {
            this.lastgammazero = this.gammazero;
            this.lastbetazero = this.betazero;
            if (this.gammazero === null) {
                this.gammazero = event.gamma;
                this.betazero = event.beta;
            } else {
                this.gammazero = (event.gamma + this.lastgammazero) / 2;
                this.betazero = (event.beta + this.lastbetazero) / 2;
            }
            this.gyroscopeSamples -= 1;
        }
        var totalAngleX = this.settings.gyroscopeMaxAngleX - this.settings.gyroscopeMinAngleX;
        var totalAngleY = this.settings.gyroscopeMaxAngleY - this.settings.gyroscopeMinAngleY;
        var degreesPerPixelX = totalAngleX / this.width;
        var degreesPerPixelY = totalAngleY / this.height;
        var angleX = event.gamma - (this.settings.gyroscopeMinAngleX + this.gammazero);
        var angleY = event.beta - (this.settings.gyroscopeMinAngleY + this.betazero);
        var posX = angleX / degreesPerPixelX;
        var posY = angleY / degreesPerPixelY;
        if (this.updateCall !== null) cancelAnimationFrame(this.updateCall);
        this.event = {
            clientX: posX + this.left,
            clientY: posY + this.top
        };
        this.updateCall = requestAnimationFrame(this.updateBind);
    };
    VanillaTilt.prototype.onMouseEnter = function onMouseEnter() {
        this.updateElementPosition();
        this.element.style.willChange = "transform";
        this.setTransition();
    };
    VanillaTilt.prototype.onMouseMove = function onMouseMove(event) {
        if (this.updateCall !== null) cancelAnimationFrame(this.updateCall);
        this.event = event;
        this.updateCall = requestAnimationFrame(this.updateBind);
    };
    VanillaTilt.prototype.onMouseLeave = function onMouseLeave() {
        this.setTransition();
        if (this.settings.reset) requestAnimationFrame(this.resetBind);
    };
    VanillaTilt.prototype.reset = function reset() {
        this.onMouseEnter();
        if (this.fullPageListening) this.event = {
            clientX: (this.settings.startX + this.settings.max) / (2 * this.settings.max) * this.clientWidth,
            clientY: (this.settings.startY + this.settings.max) / (2 * this.settings.max) * this.clientHeight
        };
        else this.event = {
            clientX: this.left + (this.settings.startX + this.settings.max) / (2 * this.settings.max) * this.width,
            clientY: this.top + (this.settings.startY + this.settings.max) / (2 * this.settings.max) * this.height
        };
        var backupScale = this.settings.scale;
        this.settings.scale = 1;
        this.update();
        this.settings.scale = backupScale;
        this.resetGlare();
    };
    VanillaTilt.prototype.resetGlare = function resetGlare() {
        if (this.glare) {
            this.glareElement.style.transform = "rotate(180deg) translate(-50%, -50%)";
            this.glareElement.style.opacity = "0";
        }
    };
    VanillaTilt.prototype.getValues = function getValues() {
        var x = void 0, y = void 0;
        if (this.fullPageListening) {
            x = this.event.clientX / this.clientWidth;
            y = this.event.clientY / this.clientHeight;
        } else {
            x = (this.event.clientX - this.left) / this.width;
            y = (this.event.clientY - this.top) / this.height;
        }
        x = Math.min(Math.max(x, 0), 1);
        y = Math.min(Math.max(y, 0), 1);
        var tiltX = (this.reverse * (this.settings.max - x * this.settings.max * 2)).toFixed(2);
        var tiltY = (this.reverse * (y * this.settings.max * 2 - this.settings.max)).toFixed(2);
        var angle = Math.atan2(this.event.clientX - (this.left + this.width / 2), -(this.event.clientY - (this.top + this.height / 2))) * (180 / Math.PI);
        return {
            tiltX: tiltX,
            tiltY: tiltY,
            percentageX: x * 100,
            percentageY: y * 100,
            angle: angle
        };
    };
    VanillaTilt.prototype.updateElementPosition = function updateElementPosition() {
        var rect = this.element.getBoundingClientRect();
        this.width = this.element.offsetWidth;
        this.height = this.element.offsetHeight;
        this.left = rect.left;
        this.top = rect.top;
    };
    VanillaTilt.prototype.update = function update() {
        var values = this.getValues();
        this.element.style.transform = "perspective(" + this.settings.perspective + "px) " + "rotateX(" + (this.settings.axis === "x" ? 0 : values.tiltY) + "deg) " + "rotateY(" + (this.settings.axis === "y" ? 0 : values.tiltX) + "deg) " + "scale3d(" + this.settings.scale + ", " + this.settings.scale + ", " + this.settings.scale + ")";
        if (this.glare) {
            this.glareElement.style.transform = "rotate(" + values.angle + "deg) translate(-50%, -50%)";
            this.glareElement.style.opacity = "" + values.percentageY * this.settings["max-glare"] / 100;
        }
        this.element.dispatchEvent(new CustomEvent("tiltChange", {
            "detail": values
        }));
        this.updateCall = null;
    };
    /**
   * Appends the glare element (if glarePrerender equals false)
   * and sets the default style
   */ VanillaTilt.prototype.prepareGlare = function prepareGlare() {
        // If option pre-render is enabled we assume all html/css is present for an optimal glare effect.
        if (!this.glarePrerender) {
            // Create glare element
            var jsTiltGlare = document.createElement("div");
            jsTiltGlare.classList.add("js-tilt-glare");
            var jsTiltGlareInner = document.createElement("div");
            jsTiltGlareInner.classList.add("js-tilt-glare-inner");
            jsTiltGlare.appendChild(jsTiltGlareInner);
            this.element.appendChild(jsTiltGlare);
        }
        this.glareElementWrapper = this.element.querySelector(".js-tilt-glare");
        this.glareElement = this.element.querySelector(".js-tilt-glare-inner");
        if (this.glarePrerender) return;
        Object.assign(this.glareElementWrapper.style, {
            "position": "absolute",
            "top": "0",
            "left": "0",
            "width": "100%",
            "height": "100%",
            "overflow": "hidden",
            "pointer-events": "none",
            "border-radius": "inherit"
        });
        Object.assign(this.glareElement.style, {
            "position": "absolute",
            "top": "50%",
            "left": "50%",
            "pointer-events": "none",
            "background-image": "linear-gradient(0deg, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 100%)",
            "transform": "rotate(180deg) translate(-50%, -50%)",
            "transform-origin": "0% 0%",
            "opacity": "0"
        });
        this.updateGlareSize();
    };
    VanillaTilt.prototype.updateGlareSize = function updateGlareSize() {
        if (this.glare) {
            var glareSize = (this.element.offsetWidth > this.element.offsetHeight ? this.element.offsetWidth : this.element.offsetHeight) * 2;
            Object.assign(this.glareElement.style, {
                "width": glareSize + "px",
                "height": glareSize + "px"
            });
        }
    };
    VanillaTilt.prototype.updateClientSize = function updateClientSize() {
        this.clientWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        this.clientHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
    };
    VanillaTilt.prototype.onWindowResize = function onWindowResize() {
        this.updateGlareSize();
        this.updateClientSize();
    };
    VanillaTilt.prototype.setTransition = function setTransition() {
        var _this = this;
        clearTimeout(this.transitionTimeout);
        this.element.style.transition = this.settings.speed + "ms " + this.settings.easing;
        if (this.glare) this.glareElement.style.transition = "opacity " + this.settings.speed + "ms " + this.settings.easing;
        this.transitionTimeout = setTimeout(function() {
            _this.element.style.transition = "";
            if (_this.glare) _this.glareElement.style.transition = "";
        }, this.settings.speed);
    };
    /**
   * Method return patched settings of instance
   * @param {boolean} settings.reverse - reverse the tilt direction
   * @param {number} settings.max - max tilt rotation (degrees)
   * @param {startX} settings.startX - the starting tilt on the X axis, in degrees. Default: 0
   * @param {startY} settings.startY - the starting tilt on the Y axis, in degrees. Default: 0
   * @param {number} settings.perspective - Transform perspective, the lower the more extreme the tilt gets
   * @param {string} settings.easing - Easing on enter/exit
   * @param {number} settings.scale - 2 = 200%, 1.5 = 150%, etc..
   * @param {number} settings.speed - Speed of the enter/exit transition
   * @param {boolean} settings.transition - Set a transition on enter/exit
   * @param {string|null} settings.axis - What axis should be enabled. Can be "x" or "y"
   * @param {boolean} settings.glare - if it should have a "glare" effect
   * @param {number} settings.max-glare - the maximum "glare" opacity (1 = 100%, 0.5 = 50%)
   * @param {boolean} settings.glare-prerender - false = VanillaTilt creates the glare elements for you, otherwise
   * @param {boolean} settings.full-page-listening - If true, parallax effect will listen to mouse move events on the whole document, not only the selected element
   * @param {string|object} settings.mouse-event-element - String selector or link to HTML-element what will be listen mouse events
   * @param {boolean} settings.reset - false = If the tilt effect has to be reset on exit
   * @param {boolean} settings.reset-to-start - true = On reset event (mouse leave) will return to initial start angle (if startX or startY is set)
   * @param {gyroscope} settings.gyroscope - Enable tilting by deviceorientation events
   * @param {gyroscopeSensitivity} settings.gyroscopeSensitivity - Between 0 and 1 - The angle at which max tilt position is reached. 1 = 90deg, 0.5 = 45deg, etc..
   * @param {gyroscopeSamples} settings.gyroscopeSamples - How many gyroscope moves to decide the starting position.
   */ VanillaTilt.prototype.extendSettings = function extendSettings(settings) {
        var defaultSettings = {
            reverse: false,
            max: 15,
            startX: 0,
            startY: 0,
            perspective: 1000,
            easing: "cubic-bezier(.03,.98,.52,.99)",
            scale: 1,
            speed: 300,
            transition: true,
            axis: null,
            glare: false,
            "max-glare": 1,
            "glare-prerender": false,
            "full-page-listening": false,
            "mouse-event-element": null,
            reset: true,
            "reset-to-start": true,
            gyroscope: true,
            gyroscopeMinAngleX: -45,
            gyroscopeMaxAngleX: 45,
            gyroscopeMinAngleY: -45,
            gyroscopeMaxAngleY: 45,
            gyroscopeSamples: 10
        };
        var newSettings = {};
        for(var property in defaultSettings){
            if (property in settings) newSettings[property] = settings[property];
            else if (this.element.hasAttribute("data-tilt-" + property)) {
                var attribute = this.element.getAttribute("data-tilt-" + property);
                try {
                    newSettings[property] = JSON.parse(attribute);
                } catch (e) {
                    newSettings[property] = attribute;
                }
            } else newSettings[property] = defaultSettings[property];
        }
        return newSettings;
    };
    VanillaTilt.init = function init(elements, settings) {
        if (elements instanceof Node) elements = [
            elements
        ];
        if (elements instanceof NodeList) elements = [].slice.call(elements);
        if (!(elements instanceof Array)) return;
        elements.forEach(function(element) {
            if (!("vanillaTilt" in element)) element.vanillaTilt = new VanillaTilt(element, settings);
        });
    };
    return VanillaTilt;
}();
if (typeof document !== "undefined") {
    /* expose the class to window */ window.VanillaTilt = $b5f6d4efc654cf78$var$VanillaTilt;
    /**
   * Auto load
   */ $b5f6d4efc654cf78$var$VanillaTilt.init(document.querySelectorAll("[data-tilt]"));
}
$b5f6d4efc654cf78$exports = $b5f6d4efc654cf78$var$VanillaTilt;


function $b8855ed206bb3c2e$export$2e2bcd8739ae039() {
    const elements = document.querySelectorAll(".js-tilt");
    (0, (/*@__PURE__*/$parcel$interopDefault($b5f6d4efc654cf78$exports))).init(elements);
}


const $d859da13df4a30ff$export$9c21a3269931e1e6 = {
    easing: "cubic-bezier(0.5, 0, 0, 1)",
    distance: "30px",
    duration: 1000,
    desktop: true,
    mobile: true
};
const $d859da13df4a30ff$export$adcf75ad64a03007 = [
    {
        element: ".hero__content",
        animation: {
            delay: 300,
            origin: window.innerWidth > 768 ? "left" : "bottom"
        }
    },
    {
        element: ".hero__visual",
        animation: {
            delay: 600,
            origin: window.innerWidth > 768 ? "right" : "bottom"
        }
    },
    {
        element: ".experience__header",
        animation: {
            delay: 400,
            origin: "bottom"
        }
    },
    {
        element: ".experience__item",
        animation: {
            delay: 500,
            origin: "bottom",
            interval: 200
        }
    },
    {
        element: ".experience__skills-header",
        animation: {
            delay: 300,
            origin: "bottom"
        }
    },
    {
        element: ".experience__marquee",
        animation: {
            delay: 400,
            origin: "bottom",
            interval: 200
        }
    },
    {
        element: ".projects__header",
        animation: {
            delay: 300,
            origin: "bottom"
        }
    },
    {
        element: ".project-card",
        animation: {
            delay: 400,
            origin: "bottom",
            interval: 200
        }
    },
    {
        element: ".contact-cta__content",
        animation: {
            delay: 400,
            origin: "bottom"
        }
    },
    {
        element: ".contact__header",
        animation: {
            delay: 300,
            origin: "bottom"
        }
    },
    {
        element: ".contact__form-col",
        animation: {
            delay: 400,
            origin: window.innerWidth > 768 ? "left" : "bottom"
        }
    },
    {
        element: ".contact__info-col",
        animation: {
            delay: 600,
            origin: window.innerWidth > 768 ? "right" : "bottom"
        }
    }
];


// --- Random color palette on each page load ---
function $35da740d59af89ba$var$hslToRgb(h, s, l) {
    s /= 100;
    l /= 100;
    const k = (n)=>(n + h / 30) % 12;
    const a = s * Math.min(l, 1 - l);
    const f = (n)=>l - a * Math.max(-1, Math.min(k(n) - 3, 9 - k(n), 1));
    return [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
}
function $35da740d59af89ba$var$applyRandomPalette() {
    const hue = Math.floor(Math.random() * 360);
    const colors = {
        "--color-primary": {
            h: hue,
            s: 100,
            l: 72
        },
        "--color-primary-dark": {
            h: hue,
            s: 100,
            l: 56
        },
        "--color-primary-medium": {
            h: hue,
            s: 80,
            l: 59
        },
        "--color-secondary": {
            h: (hue + 20) % 360,
            s: 90,
            l: 60
        },
        "--color-accent-warm": {
            h: (hue + 35) % 360,
            s: 100,
            l: 66
        }
    };
    const root = document.documentElement;
    for (const [prop, { h: h, s: s, l: l }] of Object.entries(colors)){
        const [r, g, b] = $35da740d59af89ba$var$hslToRgb(h, s, l);
        root.style.setProperty(prop, `rgb(${r}, ${g}, ${b})`);
        root.style.setProperty(`${prop}-rgb`, `${r}, ${g}, ${b}`);
    }
}
$35da740d59af89ba$var$applyRandomPalette();
// --- End random palette ---
(0, $6f019d1f45ba2738$export$2e2bcd8739ae039)((0, $d859da13df4a30ff$export$adcf75ad64a03007), (0, $d859da13df4a30ff$export$9c21a3269931e1e6));
(0, $b8855ed206bb3c2e$export$2e2bcd8739ae039)();
// Mobile navbar toggle
const $35da740d59af89ba$var$navToggle = document.querySelector(".site-nav__toggle");
const $35da740d59af89ba$var$navLinks = document.querySelector(".site-nav__links");
const $35da740d59af89ba$var$siteNav = document.querySelector(".site-nav");
if ($35da740d59af89ba$var$navToggle && $35da740d59af89ba$var$navLinks && $35da740d59af89ba$var$siteNav) $35da740d59af89ba$var$navToggle.addEventListener("click", ()=>{
    if ($35da740d59af89ba$var$siteNav.classList.contains("site-nav--open")) {
        $35da740d59af89ba$var$siteNav.classList.add("site-nav--closing");
        $35da740d59af89ba$var$siteNav.classList.remove("site-nav--open");
        setTimeout(()=>$35da740d59af89ba$var$siteNav.classList.remove("site-nav--closing"), 550);
    } else {
        $35da740d59af89ba$var$siteNav.classList.remove("site-nav--closing");
        $35da740d59af89ba$var$siteNav.classList.add("site-nav--open");
    }
});
// Close mobile nav on link click
document.querySelectorAll(".site-nav__link").forEach((link)=>{
    link.addEventListener("click", ()=>{
        if ($35da740d59af89ba$var$siteNav && $35da740d59af89ba$var$siteNav.classList.contains("site-nav--open")) {
            $35da740d59af89ba$var$siteNav.classList.add("site-nav--closing");
            $35da740d59af89ba$var$siteNav.classList.remove("site-nav--open");
            setTimeout(()=>$35da740d59af89ba$var$siteNav.classList.remove("site-nav--closing"), 550);
        }
    });
});
// Active nav link on scroll
const $35da740d59af89ba$var$sections = document.querySelectorAll("section[id]");
const $35da740d59af89ba$var$navLinksAll = document.querySelectorAll(".site-nav__link");
window.addEventListener("scroll", ()=>{
    const scrollY = window.scrollY + 100;
    $35da740d59af89ba$var$sections.forEach((section)=>{
        const top = section.offsetTop;
        const height = section.offsetHeight;
        const id = section.getAttribute("id");
        if (scrollY >= top && scrollY < top + height) $35da740d59af89ba$var$navLinksAll.forEach((link)=>{
            link.classList.remove("site-nav__link--active");
            if (link.getAttribute("href") === "#" + id) link.classList.add("site-nav__link--active");
        });
    });
    // Top section
    if (scrollY < ($35da740d59af89ba$var$sections[0]?.offsetTop || 200)) $35da740d59af89ba$var$navLinksAll.forEach((link)=>{
        link.classList.remove("site-nav__link--active");
        if (link.getAttribute("href") === "#top") link.classList.add("site-nav__link--active");
    });
    // Back to top button visibility
    const backToTop = document.querySelector(".back-to-top");
    if (backToTop) {
        if (window.scrollY > 400) backToTop.classList.add("back-to-top--visible");
        else backToTop.classList.remove("back-to-top--visible");
    }
});
// Contact form AJAX submit
const $35da740d59af89ba$var$contactForm = document.querySelector(".contact__form");
if ($35da740d59af89ba$var$contactForm) $35da740d59af89ba$var$contactForm.addEventListener("submit", async (e)=>{
    e.preventDefault();
    const btn = $35da740d59af89ba$var$contactForm.querySelector('button[type="submit"]');
    const status = $35da740d59af89ba$var$contactForm.querySelector(".contact__form-status");
    btn.disabled = true;
    btn.textContent = "Envoi en cours...";
    status.textContent = "";
    status.className = "contact__form-status";
    try {
        const res = await fetch($35da740d59af89ba$var$contactForm.action, {
            method: "POST",
            body: new FormData($35da740d59af89ba$var$contactForm),
            headers: {
                Accept: "application/json"
            }
        });
        if (res.ok) {
            status.textContent = "Message envoy\xe9 avec succ\xe8s !";
            status.classList.add("contact__form-status--success");
            $35da740d59af89ba$var$contactForm.reset();
        } else {
            status.textContent = "Une erreur est survenue, r\xe9essayez.";
            status.classList.add("contact__form-status--error");
        }
    } catch  {
        status.textContent = "Une erreur est survenue, r\xe9essayez.";
        status.classList.add("contact__form-status--error");
    }
    btn.disabled = false;
    btn.textContent = "Envoyer Message";
});
// Marquee slow on hover (smooth via playbackRate)
document.querySelectorAll(".experience__marquee").forEach((marquee)=>{
    const track = marquee.querySelector(".experience__marquee-track");
    if (!track) return;
    marquee.addEventListener("mouseenter", ()=>{
        track.getAnimations().forEach((a)=>a.playbackRate = 0.3);
    });
    marquee.addEventListener("mouseleave", ()=>{
        track.getAnimations().forEach((a)=>a.playbackRate = 1);
    });
});


//# sourceMappingURL=path0.f106531e.js.map
